<div class="w-full px-4">
  <div class="w-full flex flex-column gap-3">
    <div class="grid align-items-center mb-3">
      <h1 class="text-left col-12 md:col-9 font-bold text-3xl md:text-4xl m-0">Scholarship Manager</h1>
      <div class="col-12 md:col-3">
        <p-button icon="pi pi-user-plus" (click)="addScholarshipDialog()" label="Add Scholarship" class="w-full"
          styleClass="submitBtn w-full" />
      </div>
    </div>
    <div class="w-full flex flex-column gap-2 py-4 px-3 bg-white border-round-2xl shadow-2">
      <div class="flex align-items-center justify-content-between">
        <h2 class="text-left font-medium text-2xl" style="color: #303030;">Search</h2>
        <p-button icon="pi pi-cog" styleClass="p-button-rounded p-button-text p-button-plain"
          (click)="settingsPanel.toggle($event)" ariaLabel="Table Settings" />
      </div>
      <form [formGroup]="filterForm" (ngSubmit)="getScholarships(1)" class="w-full flex flex-wrap">
        <div class="w-full grid">
          <div class="col-12 md:col-4 lg:col-3 flex flex-column gap-1">
            <b class="font-regular text-base" style="color: #505050;">Scholarship Name</b>
            <p-autoComplete formControlName="scholarshipName" [suggestions]="schoplarshipNames" placeholder="Name"
              [ngClass]="{'ng-invalid ng-dirty': submitted && !filterForm.get('scholarshipName')?.value}" class="w-full"
              (completeMethod)="filterScholarshipNames($event)" styleClass="fullWidth" [showClear]="true">
            </p-autoComplete>
          </div>
          <div class="col-12 md:col-4 lg:col-3 flex flex-column gap-1">
            <b class="font-regular text-base" style="color: #505050;">Type Of Scholarship</b>
            <p-dropdown [options]="scholarshipOptions" styleClass="selectFull" class="w-full" optionLabel="name"
              optionValue="value" formControlName="scholarshipType" filterBy="name" [showClear]="true" appendTo="body"
              placeholder="Select Scholarship Type">
            </p-dropdown>
          </div>
          <div class="col-12 md:col-3 lg:col-2 flex flex-column gap-1">
            <b class="font-regular text-base" style="color: #505050;">Stream</b>
            <p-dropdown #streamDropdown [options]="streamOptions" styleClass="selectFull" class="w-full"
              formControlName="stream" filterBy="name" [showClear]="true" appendTo="body"
              [panelStyle]="{'max-width': (streamDropdownWidth || 200) + 'px'}" [style]="{'min-width': '120px'}"
              [placeholder]="'Select Stream'">
            </p-dropdown>
          </div>
          <div class="col-12 md:col-3 lg:col-2 flex flex-column gap-1">
            <b class="font-regular text-base" style="color: #505050;">Level</b>
            <p-dropdown [options]="levelOptions" styleClass="selectFull" class="w-full" formControlName="level"
              filterBy="name" [showClear]="true" appendTo="body" [style]="{'min-width': '120px'}"
              [placeholder]="'Select Level'">
            </p-dropdown>
          </div>
          <div class="col-12 lg:col-2">
            <div class="w-full" style="padding-top: 23px;">
              <p-button type="submit" label="Search" class="w-full" styleClass="submitBtn" />
            </div>
          </div>

        </div>
      </form>
      <p-overlayPanel #settingsPanel [style]="{width: '22rem', maxHeight: '24rem', overflowY: 'auto'}">
        <div class="flex flex-column gap-3">
          <div class="flex align-items-center gap-2 mb-2">
            <p-button icon="pi pi-refresh" styleClass="p-button-sm p-button-text p-button-secondary"
              (click)="resetColumnConfiguration()" pTooltip="Reset Columns" tooltipPosition="right"
              ariaLabel="Reset Columns" />
            <span class="font-medium">Reset Columns</span>
          </div>
          <div class="flex flex-column gap-2">
            <div *ngFor="let column of columns"
              class="flex align-items-center justify-content-between p-2 border-round">
              <span class="font-medium">{{ column.header }}</span>
              <p-inputSwitch [(ngModel)]="column.visible" (onChange)="onColumnVisibilityChange($event, column.field)"
                ariaLabel="Toggle column visibility" />
            </div>
          </div>
        </div>
      </p-overlayPanel>
    </div>

    <div class="w-full">
      <p-table *ngIf="scholarshipsList && scholarshipsList.length > 0; else noRecordsFound" [value]="scholarshipsList"
        [paginator]="scholarshipsList.length!=totalRecords" [rows]="rowSize" [totalRecords]="totalRecords"
        [first]="first" [lazy]="true" [lazyLoadOnInit]="false" [loading]="isLoading" [loadingIcon]="'pi pi-spinner'"
        (onLazyLoad)="onLazyLoad($event)" [rowsPerPageOptions]="[10, 20, 30]" [showPageLinks]="true"
        styleClass="p-datatable-gridlines tableCon" [tableStyle]="{ 'min-width': '50rem' }">
        <ng-template pTemplate="header">
          <tr>
            <th *ngFor="let column of visibleColumns" [attr.data-field]="column.field">{{column.header}}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-scholarship>
          <tr>
            <td *ngIf="isColumnVisible('schoolName')">{{scholarship.name}}</td>
            <td *ngIf="isColumnVisible('image')">
              <ng-container *ngIf="getScholarshipImage(scholarship.image)">
                <div class="image-thumbnail-container" tabindex="0">
                  <img [src]="getScholarshipImage(scholarship.image)" alt="Uploaded" class="image-thumbnail" />
                  <div class="image-preview">
                    <img [src]="getScholarshipImage(scholarship.image)" alt="Large Preview" class="image-large" />
                  </div>
                </div>
              </ng-container>
            </td>
            <td *ngIf="isColumnVisible('type')">{{typeDescriptions(scholarship.scholarshipType)}}</td>
            <td *ngIf="isColumnVisible('description')">
              <div class="white-space-nowrap overflow-hidden text-overflow-ellipsis" style="max-width: 200px;"
                [title]="scholarship.description">
                {{scholarship.description}}
              </div>
            </td>
            <td *ngIf="isColumnVisible('eligibility')">
              <div *ngIf="scholarship.eligibility">
                {{scholarship.eligibility.academicRequirements || scholarship.eligibility.testRequirements || 'View
                Details'}}
              </div>
            </td>
            <td *ngIf="isColumnVisible('deadline')">
              {{scholarship.deadLine?.exactDate | deadline}} <span
                *ngIf="scholarship.deadLine?.exactDate && scholarship.deadLine?.month">|</span>
              {{scholarship.deadLine?.month}}
            </td>
            <td *ngIf="isColumnVisible('startDate')">{{scholarship.startDate?.join(', ')}}</td>
            <td *ngIf="isColumnVisible('scholarshipAmount')">
              <div *ngFor="let amt of scholarship.scholarship?.amount">
                {{amt.amount}}
              </div>
              <div *ngIf="scholarship.scholarship?.exactNumbersUnavailable === 'true'" class="text-xs text-secondary">
                N/A</div>
            </td>
            <td *ngIf="isColumnVisible('stream')">
              {{scholarship.stream?.join(', ')}}
            </td>
            <td *ngIf="isColumnVisible('level')">
              {{scholarship.level}}
            </td>

            <td *ngIf="isColumnVisible('applicationLink')">
              <a [href]="scholarship.applicationLink" target="_blank"
                class="text-primary no-underline hover:underline" *ngIf="scholarship.applicationLink">
                Link <i class="pi pi-external-link text-xs"></i>
              </a>
            </td>
            <td *ngIf="isColumnVisible('internal.sourceUrl')">
              <a [href]="scholarship.internal?.sourceUrl" target="_blank"
                class="text-primary no-underline hover:underline" *ngIf="scholarship.internal?.sourceUrl">
                Internal Link <i class="pi pi-external-link text-xs"></i>
              </a>
            </td>

            <td *ngIf="isColumnVisible('actions')">
              <div class="flex">
                <p-button class="px-2" [loading]="isLoading" label="Edit" icon="pi pi-pen-to-square"
                  styleClass="w-7rem viewapplication" (click)="addScholarshipDialog(scholarship)" />
                <p-button class="px-2" [loading]="isLoading" label="Remove" icon="pi pi-trash"
                  styleClass="w-7rem delete" severity="danger" (click)="removeScholarship(scholarship.id)" />
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
      <ng-template #noRecordsFound>
        <div class="w-full flex flex-column align-items-center py-4 gap-5">
          <div class="w-full flex align-items-center justify-content-center">
            <img src="../../../assets/icons/nodatafound.svg" alt="" class="w-full max-w-16rem">
          </div>
          <b class="text-center font-normal text-2xl" style="color: #000086;">No Data Found !</b>
        </div>
      </ng-template>
    </div>
  </div>
</div>

<p-dialog [header]="scholarshipToEdit ? 'Update Scholarship' : 'New Scholarship'" [(visible)]="isVisible" [modal]="true"
  (visibleChange)="onDialogVisibilityChange($event)" [style]="{ width: '85rem' }" [breakpoints]="{'960px': '95vw'}">
  <div class="w-full">
    <form (ngSubmit)="upsertScholarship()" [formGroup]="newScholarshipForm" class="flex flex-column gap-4">

      <!-- SECTION 1: GENERAL INFORMATION -->
      <div class="surface-ground p-3 border-round-xl border-1 border-200">
        <h3 class="text-xl font-semibold mb-3 mt-0 text-primary flex align-items-center gap-2">
          <i class="pi pi-info-circle"></i> General Information
        </h3>
        <div class="grid">
          <div class="col-12 md:col-8">
            <div class="grid">
              <div class="col-12 md:col-6 flex flex-column gap-1">
                <label class="font-medium text-color-secondary">Scholarship Name <span
                    class="text-red-500">*</span></label>
                <input pInputText formControlName="name" placeholder="Enter scholarship name" class="w-full">
                <small class="text-red-500"
                  *ngIf="newScholarshipForm.get('name')?.invalid && (submitted || newScholarshipForm.get('name')?.touched)">Name
                  is required</small>
              </div>
              <div class="col-12 md:col-6 flex flex-column gap-1">
                <label class="font-medium text-color-secondary">University / Organisation</label>
                <input pInputText formControlName="universityOrOrganisationName" placeholder="Enter organization name"
                  class="w-full">
              </div>
              <div class="col-12 md:col-6 flex flex-column gap-1">
                <label class="font-medium text-color-secondary">Country</label>
                <p-multiSelect [options]="countryOptions" formControlName="country" optionLabel="label"
                  optionValue="value" placeholder="Select countries" display="chip" styleClass="w-full"></p-multiSelect>
              </div>
              <div class="col-12 md:col-6 flex flex-column gap-1">
                <label class="font-medium text-color-secondary">Stream</label>
                <p-multiSelect [options]="mappedStreamOptions" formControlName="stream" optionLabel="label"
                  optionValue="value" placeholder="Select streams" display="chip" styleClass="w-full"></p-multiSelect>
              </div>
              <div class="col-12 md:col-6 flex flex-column gap-1">
                <label class="font-medium text-color-secondary">Academic Level</label>
                <p-dropdown [options]="mappedLevelOptions" formControlName="level" optionLabel="label"
                  optionValue="value" placeholder="Select level" styleClass="w-full"></p-dropdown>
              </div>
              <div class="col-12 md:col-6 flex flex-column gap-1">
                <label class="font-medium text-color-secondary">Scholarship Type</label>
                <p-dropdown [options]="scholarshipOptions" formControlName="scholarshipType" optionLabel="name"
                  optionValue="value" placeholder="Select type" styleClass="w-full"></p-dropdown>
              </div>
              <div class="col-12 flex flex-column gap-1">
                <label class="font-medium text-color-secondary">Application Link (Public)</label>
                <input pInputText formControlName="applicationLink" placeholder="https://..." class="w-full">
              </div>
            </div>
          </div>
          <div class="col-12 md:col-4 flex flex-column align-items-center justify-content-center">
            <label class="font-medium text-color-secondary mb-2">Scholarship Image</label>
            <app-image-crop-upload [borderType]="'scholarship'" [aspectRatio]="1" [imageUrl]="uploadedImageUrl || ''"
              [imageClass]="'w-14rem h-14rem border-round-xl shadow-1'"
              (imageCropped)="onScholarshipImageCropped($event)"></app-image-crop-upload>
          </div>
          <div class="col-12 flex flex-column gap-1">
            <label class="font-medium text-color-secondary">Description</label>
            <textarea pInputTextarea formControlName="description" rows="3" placeholder="Detailed description..."
              class="w-full"></textarea>
          </div>
        </div>
      </div>

      <!-- SECTION 2: ELIGIBILITY DETAILS -->
      <div class="surface-ground p-3 border-round-xl border-1 border-200" formGroupName="eligibility">
        <h3 class="text-xl font-semibold mb-3 mt-0 text-primary flex align-items-center gap-2">
          <i class="pi pi-check-square"></i> Eligibility Criteria
        </h3>
        <div class="grid">
          <div class="col-12 md:col-6 flex flex-column gap-1">
            <label class="font-medium text-color-secondary">Academic Requirements</label>
            <textarea pInputTextarea formControlName="academicRequirements" rows="2" class="w-full"></textarea>
          </div>
          <div class="col-12 md:col-6 flex flex-column gap-1">
            <label class="font-medium text-color-secondary">Test Requirements (SAT, IELTS, etc.)</label>
            <textarea pInputTextarea formControlName="testRequirements" rows="2" class="w-full"></textarea>
          </div>
          <div class="col-12 md:col-4 flex flex-column gap-1">
            <label class="font-medium text-color-secondary">Nationality</label>
            <input pInputText formControlName="nationality" class="w-full">
          </div>
          <div class="col-12 md:col-4 flex flex-column gap-1">
            <label class="font-medium text-color-secondary">Age Limit / Range</label>
            <input pInputText formControlName="age" class="w-full">
          </div>
          <div class="col-12 md:col-4 flex flex-column gap-1">
            <label class="font-medium text-color-secondary">Other Criteria</label>
            <input pInputText formControlName="others" class="w-full">
          </div>
        </div>
      </div>

      <!-- SECTION 3: DEADLINE & FUNDING -->
      <div class="grid">
        <div class="col-12 md:col-6">
          <div class="surface-ground p-3 h-full border-round-xl border-1 border-200">
            <h3 class="text-xl font-semibold mb-3 mt-0 text-primary flex align-items-center gap-2">
              <i class="pi pi-calendar"></i> Deadline Information
            </h3>
            <div class="grid" formGroupName="deadLine">
              <div class="col-12 md:col-6 flex flex-column gap-1">
                <label class="font-medium text-color-secondary">Month</label>
                <p-dropdown [options]="monthOptions" formControlName="month" optionLabel="label" optionValue="value"
                  placeholder="Select month" styleClass="w-full"></p-dropdown>
              </div>
              <div class="col-12 md:col-6 flex flex-column gap-1">
                <label class="font-medium text-color-secondary">Exact Date</label>
                <input pInputText formControlName="exactDate" placeholder="e.g. 15th Jan 2025" class="w-full">
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 md:col-6">
          <div class="surface-ground p-3 h-full border-round-xl border-1 border-200">
            <h3 class="text-xl font-semibold mb-3 mt-0 text-primary flex align-items-center gap-2">
              <i class="pi pi-money-bill"></i> Funding Details
            </h3>
            <div class="flex flex-column gap-2 mb-3">
              <label class="font-medium text-color-secondary">Funding Type</label>
              <p-multiSelect [options]="fundingTypeOptions" formControlName="fundingType" optionLabel="label"
                optionValue="value" placeholder="Select types" display="chip" styleClass="w-full"></p-multiSelect>
            </div>

            <div formGroupName="scholarship">
              <div class="flex align-items-center gap-2 mb-3">
                <p-checkbox formControlName="exactNumbersUnavailable" [binary]="true" label="Exact Amount Unavailable"
                  inputId="exact_na"></p-checkbox>
              </div>

              <div formArrayName="amount">
                <div *ngFor="let amt of scholarshipAmountArray.controls; let i = index" [formGroupName]="i"
                  class="flex gap-2 mb-2 align-items-start">
                  <div class="flex-1 flex flex-column gap-1">
                    <p-dropdown [options]="currencyOptions" formControlName="currency" optionLabel="label"
                      optionValue="value" placeholder="Currency" styleClass="w-full"></p-dropdown>
                  </div>
                  <div class="flex-1 flex flex-column gap-1">
                    <input pInputText formControlName="amount" placeholder="Amount" class="w-full">
                  </div>
                  <p-button icon="pi pi-trash" (click)="removeAmount(i)"
                    styleClass="p-button-danger p-button-text p-button-rounded"></p-button>
                </div>
                <p-button type="button" icon="pi pi-plus" label="Add Amount Range" (click)="addAmount()"
                  styleClass="p-button-sm p-button-outlined w-full"></p-button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- SECTION 4: INTERNAL TRACKING -->
      <div class="surface-ground p-3 border-round-xl border-1 border-200" formGroupName="internal">
        <h3 class="text-xl font-semibold mb-3 mt-0 text-primary flex align-items-center gap-2">
          <i class="pi pi-lock"></i> Internal Tracking
        </h3>
        <div class="grid">
          <div class="col-12 md:col-4 flex flex-column gap-1">
            <label class="font-medium text-color-secondary">Last Verified Date</label>
            <p-calendar formControlName="lastVerifiedDate" [showIcon]="true" appendTo="body"
              styleClass="w-full"></p-calendar>
          </div>
          <div class="col-12 md:col-8 flex flex-column gap-1">
            <label class="font-medium text-color-secondary">Internal Source URL</label>
            <input pInputText formControlName="sourceUrl" placeholder="Internal tracking link" class="w-full">
          </div>
          <div class="col-12 flex flex-column gap-1">
            <label class="font-medium text-color-secondary">Internal Notes</label>
            <textarea pInputTextarea formControlName="notes" rows="2" class="w-full"></textarea>
          </div>
        </div>
      </div>

      <div class="flex justify-content-end gap-3 mt-4">
        <p-button label="Cancel" icon="pi pi-times" styleClass="p-button-text p-button-secondary"
          (click)="closeDialog()"></p-button>
        <p-button [disabled]="newScholarshipForm.invalid" [loading]="isLoading" label="Save Scholarship"
          icon="pi pi-save" styleClass="p-button-raised p-button-primary px-6" type="submit"></p-button>
      </div>
    </form>
  </div>
</p-dialog>